/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { TranslateModule } from '@ngx-translate/core';
import { ApiModule } from '@core/modules/api/api.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { APP_CONFIG } from './custom/config/app-config';
import { ROUTES_ACTIVATION } from './custom/config/routes-activation';
import { STEPS_CONFIG } from '@core/config/steps-config';
import { OutputAdapterService } from '@core/modules/api/services/output-adapter/output-adapter.service';
import { OutputAdapterCustomService } from './custom/services/output-adapter-custom/output-adapter-custom.service';
import { CoreModule } from '@core/core.module';
import { ApiService } from '@core/modules/api/services/api/api.service';
import { ApiCustomService } from './custom/services/api-custom/api-custom.service';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    CoreModule,
    IonicModule.forRoot({ mode: 'md' }),
    AppRoutingModule,
    ApiModule,
    TranslateModule.forRoot({
      defaultLanguage: 'it'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: 'APP_CONFIG', useValue: APP_CONFIG },
    { provide: 'STEPS_CONFIG', useValue: STEPS_CONFIG },
    { provide: 'ROUTES_ACTIVATION', useValue: ROUTES_ACTIVATION },
    {
      provide: OutputAdapterService,
      useClass: OutputAdapterCustomService
    },
    {
      provide: ApiService,
      useClass: ApiCustomService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
